import React from 'react'
import PropTypes from 'prop-types'
import { DropdownButton, MenuItem } from 'react-bootstrap'
import { useStateValue } from '../../state'
import DeleteHighlightModal from './DeleteHighlightModal'

const HighlightActionMenu = props => {
  let [currentState, dispatch] = useStateValue()

  let [modalState, setModalState] = React.useState(false)
  let toggleModal = () => {
    setModalState(!modalState)
  }

  const editNote = hId => {
    let hIds = [...currentState.editingNote]
    if (!hIds.includes(hId)) {
      hIds.push(hId)
    }
    dispatch({ type: 'editNote', payload: hIds })
  }

  return (
    <div className="btn-group pull-right">
      <DropdownButton title="Actions" id={props.hId}>
        <MenuItem
          eventKey={1}
          href={`/reader/web/${props.coursenum}/${props.anchor}/`}
        >
          <div className="icon icon_arrow_up_right6 icon_color_green" />
          Go To
        </MenuItem>
        {props.userIsOwner && (
          <React.Fragment>
            <MenuItem eventKey={2} onClick={() => editNote(props.hId)}>
              <div className="icon icon_pencil3 icon_color_blue" />
              Edit
            </MenuItem>
            <MenuItem eventKey={3} onClick={toggleModal}>
              <div className="icon icon_cancel icon_color_red" />
              Remove
            </MenuItem>
            <DeleteHighlightModal
              toggleModal={toggleModal}
              show={modalState}
              close={toggleModal}
              hId={props.hId}
            />
          </React.Fragment>
        )}
      </DropdownButton>
    </div>
  )
}

HighlightActionMenu.propTypes = {
  hId: PropTypes.string,
  coursenum: PropTypes.string,
  anchor: PropTypes.string,
  userIsOwner: PropTypes.bool,
}

export default HighlightActionMenu
